import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import { camelCase, mapKeys } from "lodash";
import { bool, func, node, oneOfType, shape, string } from "prop-types";

import { contactConfirmationGA } from "../../../../analytics/ga";
import executeRouteLogin from "../../../../helpers/executeRouteLogin";
import getCurrentUser from "../../../../helpers/getCurrentUser";
import { TextBold } from "../../styled";
import AccountCreatedConfirmation from "./confirmations/AccountCreatedConfirmation";
import BlankConfirmation from "./confirmations/BlankConfirmation";
import LoggedInUserConfirmation from "./confirmations/LoggedInUserConfirmation";
import PasswordRequestedConfirmation from "./confirmations/PasswordRequestedConfirmation";
import PasswordRequiredToRegisterConfirmation from "./confirmations/PasswordRequiredToRegisterConfirmation";
import SSOUserConfirmation from "./confirmations/SSOUserConfirmation";
import VerificationSentConfirmation from "./confirmations/VerificationSentConfirmation";

class ContactConfirmation extends React.Component {
  state = {
    confirmationContentKey: "DefaultContent",
    ssoUrl: ""
  };

  componentDidMount() {
    this.initConfirmation();
  }

  getContent = () => {
    const confirmationMapping = {
      AccountCreated: AccountCreatedConfirmation,
      DefaultContent: BlankConfirmation,
      LoggedInUser: LoggedInUserConfirmation,
      PasswordRequested: PasswordRequestedConfirmation,
      PasswordRequiredToRegister: PasswordRequiredToRegisterConfirmation,
      SSOUser: SSOUserConfirmation,
      VerificationSent: VerificationSentConfirmation
    };

    const confirmationText =
      typeof this.props.data.confirmationText === "string"
        ? this.textWithBold(this.props.data.confirmationText)
        : this.props.data.confirmationText;

    const confirmationProps = {
      data: {
        agent: this.props.data.agent,
        agentUrl: this.props.data.agentUrl,
        confirmationHeader: this.props.data.confirmationHeader,
        confirmationText,
        email: this.props.data.email,
        logoUrl: this.props.data.logoUrl,
        origin: "contact",
        sourceGroup: this.props.data.sourceGroup,
        ssoUrl: this.state.ssoUrl
      },
      handleCloseModal: this.props.handleCloseModal,
      isModalOpen: this.props.isModalOpen,
      scenario: this.props.scenario,
      setScenario: this.props.setScenario,
      setTheme: this.props.setTheme,
      topPosition: this.props.topPosition
    };
    const Content = confirmationMapping[this.state.confirmationContentKey];

    return <Content {...confirmationProps} />;
  };

  textWithBold = text => {
    const matches = text.match(/(.*)<b>(.*)<\/b>(.*)/);

    if (matches) {
      return (
        <Text as="span" type="sm">
          {matches[1]}
          <TextBold as="span" type="sm">
            {matches[2]}
          </TextBold>
          {matches[3]}
        </Text>
      );
    }

    return (
      <Text as="span" type="sm">
        {text}
      </Text>
    );
  };

  handleCompleted = data => {
    // GA starts
    const analyticsData = mapKeys(
      data.route_login.analytics_data,
      (value, key) => camelCase(key)
    );
    analyticsData.source = "contact";
    localStorage.setItem("analytics", JSON.stringify(analyticsData));
    contactConfirmationGA.modalIsOpened(
      analyticsData.source,
      analyticsData.flow
    );

    if (data.route_login.__typename === "AccountCreated") {
      contactConfirmationGA.accountIsCreated(
        analyticsData.source,
        analyticsData.flow
      );
    }
    // GA ends
  };

  initConfirmation = async () => {
    const loggedInUser = await getCurrentUser();

    if (loggedInUser) {
      this.setState({ confirmationContentKey: "LoggedInUser" });
      return false;
    }

    this.triggerRouteLogin();

    return false;
  };

  triggerRouteLogin = async () => {
    const routeLoginResult = await executeRouteLogin(
      this.props.data.email,
      "contact"
    );

    this.handleCompleted(routeLoginResult.data);
    this.props.onRouteLoginCompleted();
    this.setState({
      confirmationContentKey: routeLoginResult.data.route_login.__typename,
      ssoUrl: routeLoginResult.data.route_login.url
    });
  };

  render() {
    return this.getContent();
  }
}

ContactConfirmation.propTypes = {
  data: shape({
    agent: string,
    agentUrl: string,
    confirmationHeader: string,
    confirmationText: oneOfType([string, node]).isRequired,
    email: string.isRequired,
    logoUrl: string,
    origin: string.isRequired,
    sourceGroup: string
  }).isRequired,
  handleCloseModal: func.isRequired,
  isModalOpen: bool.isRequired,
  onRouteLoginCompleted: func.isRequired,
  scenario: string.isRequired,
  setScenario: func.isRequired,
  setTheme: string.isRequired,
  topPosition: string.isRequired
};

export default ContactConfirmation;
